export default "__VITE_ASSET__Bi82zLKI__"